import Radium from '@flipdish/radium';
import * as React from 'react';
import { Link } from 'react-router';
import * as Api from '../../Api';
import * as Data from '../../Data';
import * as Routes from '../../Routes';
const tinycolor = require('tinycolor2');

interface Props {
  DeliveryEnabled: boolean;
  PickupEnabled: boolean;
  Geo: Api.Geo;
  DeliveryLocation: Api.DeliveryLocation | null;
  Restaurant: Routes.RouteRestaurant;
  AppConfig: Data.Async<Api.AppConfig>;
  Type: string;
  translate: any;
  AppDesignScheme: Api.AppDesignScheme;
  menu: Api.MenuReposnse | Api.ReadonlyMenuResponse | null;
  isDark: boolean;
}

interface State {}

class LocationHeader extends React.Component<Props & Routes.Routes, State> {
  public restaurantName = (): string => {
    const { Restaurant, AppConfig, menu, params } = this.props;

    let categoryNameTranslation = 'Restaurant_lowercase';

    if (AppConfig.status === 'success') {
      const { Category } = AppConfig.data;

      switch (Category) {
        case 0:
          categoryNameTranslation = 'Restaurant_lowercase';
          break;
        case 1:
          categoryNameTranslation = 'Cafe_lowercase';
          break;
        case 2:
          categoryNameTranslation = 'Store_lowercase';
          break;
        default:
          categoryNameTranslation = 'Restaurant_lowercase';
      }

      switch (Restaurant.status) {
        case 'none':
        case 'pending':
          return `${this.props.translate('Loading_category_name', {
            categoryName: this.props.translate(categoryNameTranslation)
          })}...`;
        default:
          const stores = (menu && (menu as any).ConcessionStores) || [];
          if (params.concessionStoreId && stores && stores.length > 0) {
            const concessionStoreId = parseInt(`${params.concessionStoreId}`);
            const index = stores.findIndex(
              store => store.ConcessionStoreId === concessionStoreId
            );
            if (index !== -1 && stores[index]) {
              return stores[index].Name + ', ' + Restaurant.data.RestaurantName;
            }
          }
          return Restaurant.data.RestaurantName;
      }
    }

    return '';
  };
  public orderCaption = (): JSX.Element | null => {
    const { Restaurant, AppDesignScheme, isDark, AppConfig } = this.props;

    const styles = {
      primary: {
        color: AppDesignScheme.Primary
      },
      secondary: {
        color: AppDesignScheme.Secondary
      },
      tertiary: {
        color: AppDesignScheme.Tertiary
      }
    };

    if (Restaurant.status === 'none' || Restaurant.status === 'pending') {
      //return (<h3 className="tertiary clear-margins">Loading</h3>);
      return null;
    }

    const tableServiceIndex =
      Restaurant.data.DeliveryType === Api.DeliveryType.Collection &&
      Restaurant.data.PickupLocationTypes.findIndex(
        PickupLocation => PickupLocation === Api.PickupLocationType.TableService
      );

    const isTableServiceOnly =
      Restaurant.data.DeliveryType === Api.DeliveryType.Collection &&
      Restaurant.data.PickupLocationTypes.length === 1 &&
      tableServiceIndex != -1;

    const TableServiceCategory =
      Restaurant.data.DeliveryType === Api.DeliveryType.Collection
        ? Restaurant.data.TableServiceCatagory ||
          Api.TableServiceCategory.Generic
        : Api.TableServiceCategory.Generic;

    const TableServiceDelivery =
      (TableServiceCategory === Api.TableServiceCategory.Area ||
        TableServiceCategory === Api.TableServiceCategory.House ||
        TableServiceCategory === Api.TableServiceCategory.ParkingBay ||
        TableServiceCategory === Api.TableServiceCategory.Room ||
        TableServiceCategory === Api.TableServiceCategory.Villa) &&
      isTableServiceOnly;

    if (Restaurant.data.DeliveryType === Api.DeliveryType.Collection) {
      if (TableServiceDelivery) {
        return (
          <div className="location-header__address flex flex-align-center">
            <i
              className="fa fa-motorcycle secondary"
              style={styles.secondary}
              aria-hidden="true"
            />
            <h2
              className="tertiary clear-margins location-header__address__type fd-h4"
              style={isDark ? styles.primary : styles.tertiary}
            >
              {this.props.translate('Delivery')}:
            </h2>
            <p
              className="tertiary clear-margins bold fd-h4"
              style={isDark ? styles.primary : styles.tertiary}
            >
              {Restaurant.data.PhysicalRestaurantAddress}
            </p>
          </div>
        );
      } else {
        return (
          <div className="location-header__address flex flex-align-center">
            <i
              className="material-icons secondary"
              style={styles.secondary}
              aria-hidden="true"
            >
              directions_walk
            </i>
            <h2
              className="tertiary clear-margins location-header__address__type fd-h4"
              style={isDark ? styles.primary : styles.tertiary}
            >
              {this.props.translate('Collection')}:
            </h2>
            <p
              className="tertiary clear-margins bold fd-h4"
              style={isDark ? styles.primary : styles.tertiary}
            >
              {Restaurant.data.PhysicalRestaurantAddress}
            </p>
          </div>
        );
      }
    }

    const dl = this.props.DeliveryLocation;

    if (!dl) {
      console.log('No delivery location specified for delivery header');
      return (
        <h2 className="tertiary clear-margins fd-h4" style={styles.tertiary}>
          {this.props.translate('Delivery')}
        </h2>
      );
    }

    if (AppConfig.status != 'success') {
      return null;
    }

    return (
      <div
        className={`location-header__address flex flex-align-${
          AppConfig.data.DeliveryAddressLayout === 2 ? 'start' : 'center'
        }`}
      >
        <i
          className="fa fa-motorcycle secondary"
          style={styles.secondary}
          aria-hidden="true"
        />
        <h2
          className="tertiary clear-margins location-header__address__type fd-h4"
          style={isDark ? styles.primary : styles.tertiary}
        >
          {this.props.translate('Delivery')}:
        </h2>
        {AppConfig.data.DeliveryAddressLayout === 2 ? (
          <div className="flex flex-column">
            <p
              className="tertiary clear-margins bold fd-h4"
              style={isDark ? styles.primary : styles.tertiary}
            >
              {dl.Street + ','}
            </p>
            {dl.Building ? (
              <p
                className="tertiary clear-margins bold fd-h4"
                style={isDark ? styles.primary : styles.tertiary}
              >
                {dl.Building}
              </p>
            ) : null}
            <p
              className="tertiary clear-margins bold fd-h4"
              style={isDark ? styles.primary : styles.tertiary}
            >
              {dl.Town}
              {!!dl.PostCode ? `, ${dl.PostCode}` : ''}
            </p>
          </div>
        ) : (
          <p
            className="tertiary clear-margins bold fd-h4"
            style={isDark ? styles.primary : styles.tertiary}
          >
            {dl.Building + ' ' + dl.Street}
          </p>
        )}
      </div>
    );
  };

  public otherType = (): JSX.Element | null => {
    const { Restaurant, AppConfig, AppDesignScheme, isDark } = this.props;

    const styles = {
      hr: {
        borderColor: AppDesignScheme.Secondary
      },
      primary: {
        color: AppDesignScheme.Primary
      },
      secondary: {
        color: AppDesignScheme.Secondary
      },
      tertiary: {
        color: AppDesignScheme.Tertiary
      },
      buttonPrimary: {
        backgroundColor: tinycolor(AppDesignScheme.Primary)
          .darken(3)
          .toString(),
        borderColor: AppDesignScheme.Secondary,
        ':hover': {
          borderColor: AppDesignScheme.Secondary
        },
        ':active': {},
        ':focus': {
          borderColor: AppDesignScheme.Secondary
        }
      },
      darkButtonPrimary: {
        backgroundColor: 'transparent',
        borderColor: AppDesignScheme.Primary,
        ':hover': {
          borderColor: AppDesignScheme.Secondary
        },
        ':active': {},
        ':focus': {
          borderColor: AppDesignScheme.Secondary
        }
      },
      buttonActive: {
        backgroundColor: tinycolor(AppDesignScheme.Secondary)
          .darken(10)
          .toString()
      },
      buttonHover: {
        backgroundColor: AppDesignScheme.Secondary
      }
    };

    switch (Restaurant.status) {
      case 'none':
      case 'pending':
        return null;
      //return (<h3 className="tertiary clear-margins">Loading</h3>);
      default:
        break;
    }

    if (AppConfig.status != 'success') {
      //return (<h3 className="tertiary clear-margins">Loading</h3>);
      return null;
    }

    const { Category, DisplayPickupRestaurantListScreen } = AppConfig.data;

    let categoryNameTranslation = '';

    switch (Category) {
      case 0:
        categoryNameTranslation = 'Restaurant_lowercase';
        break;
      case 1:
        categoryNameTranslation = 'Cafe_lowercase';
        break;
      case 2:
        categoryNameTranslation = 'Store_lowercase';
        break;
      default:
        categoryNameTranslation = 'Restaurant_lowercase';
    }

    switch (Restaurant.data.DeliveryType) {
      case Api.DeliveryType.Collection:
        return this.props.DeliveryEnabled &&
          DisplayPickupRestaurantListScreen ? (
          <div className="location-header__buttons">
            <Link
              to="/collection"
              className="flex-one flex"
              data-fd="restaurant-collect-different"
            >
              <div
                className="fd-button fd-button--primary fd-button--big flex flex-one flex-align-center flex-justify-center"
                key="collection-button"
                style={
                  [
                    isDark ? styles.darkButtonPrimary : styles.buttonPrimary,
                    Radium.getState(this.state, 'collection-button', ':active')
                      ? styles.buttonActive
                      : Radium.getState(
                          this.state,
                          'collection-button',
                          ':hover'
                        )
                      ? styles.buttonHover
                      : null
                  ] as any
                }
              >
                <i
                  className="secondary fa fa-shopping-basket"
                  aria-hidden="true"
                  style={
                    Radium.getState(
                      this.state,
                      'collection-button',
                      ':hover'
                    ) ||
                    Radium.getState(this.state, 'collection-button', ':active')
                      ? styles.primary
                      : styles.secondary
                  }
                />
                <p
                  className="clear-margins secondary"
                  style={
                    Radium.getState(
                      this.state,
                      'collection-button',
                      ':hover'
                    ) ||
                    Radium.getState(this.state, 'collection-button', ':active')
                      ? styles.primary
                      : isDark
                      ? styles.primary
                      : styles.secondary
                  }
                >
                  {this.props.translate('Collect_from_a_different_category', {
                    categoryName: this.props.translate(categoryNameTranslation)
                  })}
                </p>
              </div>
            </Link>
          </div>
        ) : null;
      case Api.DeliveryType.Delivery:
        return this.props.PickupEnabled && DisplayPickupRestaurantListScreen ? (
          <div className="flex flex-align-center flex-justify-between location-header__buttons location-header__buttons--two">
            <Link
              to="/delivery"
              className="flex-one flex"
              data-fd="restaurant-delivery-different"
            >
              <div
                className="fd-button fd-button--primary flex flex-one flex-align-center flex-justify-center"
                key="location-button"
                style={
                  [
                    isDark ? styles.darkButtonPrimary : styles.buttonPrimary,
                    Radium.getState(this.state, 'location-button', ':active')
                      ? styles.buttonActive
                      : Radium.getState(this.state, 'location-button', ':hover')
                      ? styles.buttonHover
                      : null
                  ] as any
                }
              >
                <i
                  className="secondary icon_pin"
                  aria-hidden="true"
                  style={
                    Radium.getState(this.state, 'location-button', ':hover') ||
                    Radium.getState(this.state, 'location-button', ':active')
                      ? styles.primary
                      : styles.secondary
                  }
                />
                <p
                  className="clear-margins secondary"
                  style={
                    Radium.getState(this.state, 'location-button', ':hover') ||
                    Radium.getState(this.state, 'location-button', ':active')
                      ? styles.primary
                      : isDark
                      ? styles.primary
                      : styles.secondary
                  }
                >
                  {this.props.translate('Select_a_different_location')}
                </p>
              </div>
            </Link>
            <div className="flex flex-align-center flex-justify-center location-header__buttons__or">
              <hr style={styles.hr} />
              <p
                className="clear-margins tertiary fd-h4"
                style={isDark ? styles.primary : styles.tertiary}
              >
                {this.props.translate('Or')}
              </p>
              <hr style={styles.hr} />
            </div>
            <Link
              to="/collection"
              className="flex-one flex"
              data-fd="restaurant-order-collection"
            >
              <div
                className="fd-button fd-button--primary flex flex-one flex-align-center flex-justify-center"
                key="collection-button"
                style={
                  [
                    isDark ? styles.darkButtonPrimary : styles.buttonPrimary,
                    Radium.getState(this.state, 'collection-button', ':active')
                      ? styles.buttonActive
                      : Radium.getState(
                          this.state,
                          'collection-button',
                          ':hover'
                        )
                      ? styles.buttonHover
                      : null
                  ] as any
                }
              >
                <i
                  className="secondary fa fa-shopping-basket"
                  aria-hidden="true"
                  style={
                    Radium.getState(
                      this.state,
                      'collection-button',
                      ':hover'
                    ) ||
                    Radium.getState(this.state, 'collection-button', ':active')
                      ? styles.primary
                      : styles.secondary
                  }
                />
                <p
                  className="clear-margins secondary"
                  style={
                    Radium.getState(
                      this.state,
                      'collection-button',
                      ':hover'
                    ) ||
                    Radium.getState(this.state, 'collection-button', ':active')
                      ? styles.primary
                      : isDark
                      ? styles.primary
                      : styles.secondary
                  }
                >
                  {this.props.translate('Order_for_collection')}
                </p>
              </div>
            </Link>
          </div>
        ) : (
          <div className="location-header__buttons">
            <Link to="/delivery" className="flex-one flex">
              <div
                className="fd-button fd-button--primary fd-button--big flex flex-one flex-align-center flex-justify-center"
                key="location-button"
                style={
                  [
                    isDark ? styles.darkButtonPrimary : styles.buttonPrimary,
                    Radium.getState(this.state, 'location-button', ':active')
                      ? styles.buttonActive
                      : Radium.getState(this.state, 'location-button', ':hover')
                      ? styles.buttonHover
                      : null
                  ] as any
                }
              >
                <i
                  className="secondary icon_pin"
                  aria-hidden="true"
                  style={
                    Radium.getState(this.state, 'location-button', ':hover') ||
                    Radium.getState(this.state, 'location-button', ':active')
                      ? styles.primary
                      : styles.secondary
                  }
                />
                <p
                  className="clear-margins secondary"
                  style={
                    Radium.getState(this.state, 'location-button', ':hover') ||
                    Radium.getState(this.state, 'location-button', ':active')
                      ? styles.primary
                      : isDark
                      ? styles.primary
                      : styles.secondary
                  }
                >
                  {this.props.translate('Select_a_different_location')}
                </p>
              </div>
            </Link>
          </div>
        );
    }
  };

  public backLink = (): JSX.Element | null => {
    const { Type, AppConfig, AppDesignScheme, isDark, params } = this.props;

    if (AppConfig.status != 'success') {
      return null;
    }

    const { DisplayPickupRestaurantListScreen } = AppConfig.data;

    const link =
      !DisplayPickupRestaurantListScreen && Type === 'collection'
        ? '/where'
        : params.concessionStoreId
        ? `/concession/${params.vrid}/${params.id}`
        : `/${Type}`;

    const styles = {
      primary: {
        color: AppDesignScheme.Primary
      },
      tertiary: {
        color: AppDesignScheme.Tertiary
      },
      nav: {
        ':hover': {},
        ':active': {}
      },
      secondaryActive: {
        color: tinycolor(AppDesignScheme.Secondary)
          .darken(10)
          .toString()
      },
      secondaryHover: {
        color: tinycolor(AppDesignScheme.Secondary)
          .darken(5)
          .toString()
      }
    };

    return (
      <Link to={link} data-fd="restaurant-back">
        <div
          key="fd-nav"
          className="fd-nav flex flex-align-center"
          style={styles.nav as any}
        >
          <i
            className="arrow_carrot-left tertiary"
            aria-hidden="true"
            style={
              Radium.getState(this.state, 'fd-nav', ':active')
                ? styles.secondaryActive
                : Radium.getState(this.state, 'fd-nav', ':hover')
                ? styles.secondaryHover
                : isDark
                ? styles.primary
                : styles.tertiary
            }
          />
          <p
            className="inline-block clear-margins tertiary bold"
            style={
              Radium.getState(this.state, 'fd-nav', ':active')
                ? styles.secondaryActive
                : Radium.getState(this.state, 'fd-nav', ':hover')
                ? styles.secondaryHover
                : isDark
                ? styles.primary
                : styles.tertiary
            }
          >
            <u>{this.props.translate('Back')}</u>
          </p>
        </div>
      </Link>
    );
  };

  public render(): JSX.Element {
    const { AppDesignScheme, isDark } = this.props;

    const styles = {
      primary: {
        color: AppDesignScheme.Primary
      },
      secondary: {
        color: AppDesignScheme.Secondary
      },
      hr: {
        borderColor: AppDesignScheme.Secondary
      }
    };

    return (
      <div className="location-header">
        <h1
          id="skip-to-content"
          className="secondary"
          style={isDark ? styles.primary : styles.secondary}
        >
          {this.restaurantName()}
        </h1>
        {this.backLink()}
        {this.orderCaption()}
        <div className="row">
          <div className="col-md-8 col-lg-8 col-sm-12">
            {this.otherType()}
            <hr className="hidden-sm hidden-xs" style={styles.hr} />
          </div>
        </div>
      </div>
    );
  }
}

export default Radium(LocationHeader);
